module.exports = __webpack_public_path__ + "img/logo_京东1.e33ee50c.png";